window.VGLog = function (type, arr = []) {
	if (!type) return;

	switch (type) {
		case 'error':
			arr.forEach(function (item) {
				console.error(item);
			});
			break;
		case 'debug':
			arr.forEach(function (item) {
				console.debug(item);
			});
			break;
		case 'success':
			if (arr.length) {
				arr.forEach(function (item) {
					console.log("%c" + item, "color: green;");
				});
			}
			break;
		default:
			console.log(type);
			break;
	}
};

window.visibleSection = function (target, position, offset = 0){
	let visible = false ;

	const targetPosition = {
			top: window.pageYOffset + target.getBoundingClientRect().top,
			bottom: window.pageYOffset + target.getBoundingClientRect().bottom,
			center: window.pageYOffset + target.getBoundingClientRect().top,
		},
		windowPosition = {
			top: window.pageYOffset,
			bottom: window.pageYOffset + document.documentElement.clientHeight
		};

	if(position === 'top') {
		targetPosition.top -= offset;
		if (targetPosition.top < windowPosition.top &&
			windowPosition.top < targetPosition.bottom) {
			visible = true;
		}
	}

	if(position === 'bottom') {
		targetPosition.top += offset;
		if (targetPosition.bottom > windowPosition.top &&
			targetPosition.top < windowPosition.bottom) {
			visible = true;
		}
	}

	if(position === 'center') {
		if(targetPosition.center < windowPosition.top +
			(document.documentElement.clientHeight / 2) &&
		 	windowPosition.top < targetPosition.bottom) {
			visible = true;
		}
	}

	return visible;
};

window.getEl = function (el, container) {
	let elements = document.querySelectorAll(el);

	if(container) {
		elements = container.querySelectorAll(el);
	}

	return [...elements];
};

window.scrollToSection = function (clicked, offset = 0) {
	let elements = getEl(clicked);
	let id = '';
	elements.forEach((element) => {
		element.addEventListener('click', (e) => {
			id = e.target.getAttribute('id');

			getEl(`[data-id=${id}]`).forEach((el) => {
				let lengthSection = el.getBoundingClientRect().top + window.pageYOffset;
				window.scrollTo({
					top: lengthSection - offset,
					behavior: 'smooth'
				});
			})
		});
	});
};

